/* eslint-disable no-unsafe-finally */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line no-unused-vars
// Added this as the response structure is different for all different route paths of dashboard api
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { HttpStatusCode } from 'axios';
import { RootState } from '../app/Store';
import { sendToUniversalDashboard } from '../middleware/TransferUniversalDashboardDataService';
import { ITransferUniversalDashBoardData } from '../types/CommonTypes';
import { API_STATUS_CONSTANT } from '../constants/StepConstants';

interface IDashboardState {
	responseData: any;
	responseStatus: string;
}
const initialState: IDashboardState = {
	responseData: null,
	responseStatus: 'idle',
};

export const TransferUniversalDashboardData = createAsyncThunk(
	'dashboard/postData',
	async (payload: ITransferUniversalDashBoardData, { dispatch }) => {
		try {
			const response = await sendToUniversalDashboard(payload);
			if (response.status === HttpStatusCode.Ok) {
				dispatch(setUniversalDashboardReducer(response?.data?.data));
				dispatch(setTransferDashboardDataResponse(API_STATUS_CONSTANT.SUCCESS));
			} else {
				dispatch(setTransferDashboardDataResponse(API_STATUS_CONSTANT.FAILED));
			}
		} catch (e) {
			dispatch(setTransferDashboardDataResponse(API_STATUS_CONSTANT.FAILED));
		} finally {
			return {
				id: '',
				pageTitle: '',
				pageSubtitle: '',
				visitStartTime: '',
				visitEndTime: null,
				pageURL: '',
				browser: '',
				os: '',
			};
		}
	}
);
const universalDashboardSlice = createSlice({
	name: 'dashboard',
	initialState,
	reducers: {
		setUniversalDashboardReducer: (state, action) => {
			state.responseData = action.payload;
		},
		setTransferDashboardDataResponse: (
			state,
			action: PayloadAction<string>
		) => {
			state.responseStatus = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(TransferUniversalDashboardData.pending, (state) => {
			state.responseStatus = API_STATUS_CONSTANT.LOADING;
		});
	},
});

export const selectUniversalDashboardResponse = (state: RootState) =>
	state.universalDashboard.responseData;
export const selectUniversalDashboardResponseStatus = (state: RootState) =>
	state.universalDashboard.responseStatus;
export const {
	setUniversalDashboardReducer,
	setTransferDashboardDataResponse,
} = universalDashboardSlice.actions;
export default universalDashboardSlice.reducer;
